module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/167-macao-133b48c0650e1a4a0deacae4692113e0.svg";